import type { FormInstance } from "antd/es/form/hooks/useForm"
import type { NamePath } from "antd/es/form/interface"
import dayjs, { type Dayjs } from "dayjs"

import { DATE_FORMAT } from "../date/date.ts"

interface DateAutoFillOptions<T> {
  form: FormInstance<T>
  endDatePath: NamePath<T>
  additionalEndDatePaths?: NamePath<T>[]
  format?: string
}

export function dateAutoFill<T = unknown>({
  form,
  endDatePath,
  additionalEndDatePaths,
  format = DATE_FORMAT
}: DateAutoFillOptions<T>) {
  return (startDate: string | number | Dayjs | Date | null | undefined) => {
    if (!startDate) return

    const allEndPaths = [endDatePath, ...(additionalEndDatePaths ?? [])]

    allEndPaths.forEach((path) => {
      const endDate = form.getFieldValue(path)

      if (!endDate) {
        form.setFieldValue(path, dayjs(startDate).format(format))
        form.validateFields([path].flat())
      }
    })
  }
}
